module.exports = {
  // NKC web
  // ===========================PRODUCTION===========================
  configbaseUrl: "https://ais.watsoo.com/ais-config/config",
  websocketBaseUrl: "http://staging.watsoo.com:8085/watsoo-vts-nkc/",
  // websocketBaseUrl: "https://192.168.12.57:8080/",
  // configbaseUrl: "http://staging.watsoo.com:8085/client_config",
  // configbaseUrl:"https://cd76-182-156-19-18.ngrok-free.app/client_config/",
  // Username: "admin",
  // Password:'rapid#2021',
  // Password: "NKC#2018",
  // Password: "R@pids0ft",
  // ============================END=====================================
  // Username:'admin',
  // Password:'R@pids0ft ',
  // apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw", // production
  // apiKey: "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk", //staging
  apiKey:
    window.location.hostname === "localhost" ||
    window.location.hostname.startsWith("192.")
      ? "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk"
      : "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",

  NkcWeb: true,
  kdhToken: "khdvts",
  // VTSWeb:false,
  // BJBWeb:false,
  version: 24.001,
  localhost: "fmsstaging",

  // Api endpoint   name
  apiName: {
    setDefaultDashboard: "api/v1/setUserDefaultDashboard",
    getVehicleDetails: "v1/getFuelDashboard",
    companyList: "api/v1/company/all",
    DriverAttendanceList: "api/driver-attendance",
    addNewCompany: "api/v1/company/add",
    AddChainage: `api/v1/import/excelFile`,
    AddPolyline: "/api/v2/import/excelFile",
    GetLatLngBySite: "api/v1/siteConstruction/Order",
    UploadFileOnAWs: "uploadFile",
    loginApi: "v2/login",
    UserList: "api/v1/user/all",
    AddUser: "api/v1/user/add",
    ActiveUser: "api/v1/user/active/inactive",
    UpdateUser: "api/v1/user/update",
    GetUserById: "api/v1/user",
    DesignationList: "v1/designation",
    permission_category: "v1/permission_category",
    RoleList: "v1/role/all",
    SiteList: "api/v1/site/all",
    AddSiteAccess: "api/v1/add/user/site/role",
    RemoveSiteAccess: "api/v1/remove/user/site/role",
    AddRole: "v1/role/add",
    VehicleList: "api/v4/vehicle/all",
    VehicleTypeList: "api/v1/all/vehicle-type",
    ActiveVehicle: "api/v1/vehicle/active/inactive",
    AddVehicle: "api/v1/vehicle/add",
    VehicleById: "api/v1/vehicle/view",
    UpdateVehicle: "api/v1/vehicle/update",
    VendorList: "api/v1/vendor/all",
    AddVendor: "api/v1/vendor/add",
    UpdateVendor: "api/v1/vendor/update",
    VendorById: "api/v1/vendor/view",
    ActiveVendor: "api/v1/vendor/active/inactive",
    DriverList: "api/v1/driver/all",
    DocumentList: "api/v1/documents/all",
    RouteList: "api/v1/route/all",
    AddRoute: "api/v1/route/add",
    ActiveRoute: "api/v1/route/active/inactive",
    RouteById: "api/v1/route/id",
    UpdateRoute: "api/v1/route/update",
    SyncVehicle: "api/v1/sync/vehicle",
    DeleteFile: "deleteFiles",
    EtpOrder: "api/v1/etp/orders/view",
    TotalVendorDashboard: "api/v1/dashbord/status",
    fetchAddress: "address/v1/fetch_address",
    totalInstallGps: "api/v1/dashbord/vehicle/status",
    removeGeoFench: "api/v1/delete/geofence",
    CreateTrip: "api/v1/etp/orders/create",
    TripList: "api/v2/etp/orders/get/all",
    MaterialType: "api/v1/all/material-type",
    DestinationTripSite: "api/v1/get_destinations_from_source",
    ViewTrip: "api/v1/etp/orders/view",
    NotificationAlert: "api/v1/alert/get_all",
    KmlFileUploding: "api/uploadKmlData",
    getFuelDashboard: "getFuelDashboard",
    routeSiteSubSite: "api/v1/site/route/sub_site/all",
    removeGpsFromVehicle: "api/v1/remove/vehicle",
    routeDetele: "api/v1/route/delete",
    auditLog: "api/v1/auditLog",
    AllpermissionName: "api/v1/permission",
    ActiveRoutes: "api/v1/get/active/routes",
    UptimeReport: "api/v1/vehicle/active/inactive/history",
    DieselValue: "api/saveFuelPrice",
    GetNotificationList: "api/v1/get/all/notification/configuration",
    GetDetailList: "api/v1/get/notification/configuration",
    //  AddNotification: "api/v1/create/notification/configuration",
    AddNotification: "api/v3/create/notification/configuration",
    EditNotification: "api/v1/edit/notification/configuration",
    NotificationType: "api/v1/get/notification/type",
    AllRemarksShowDetails: "v1/get/all/fuel/droppage/alert/remark",
    Addremarks: "v1/save/fuel/droppage/alert/remarks",
    AllRemarksShowDetails1: "v1/get/all/wire/cut/alert/remark",
    Addremarks1: "v1/save/wire/cut/alert/remarks",
    clientDataFromApi: "/api/get/company/config",
    VehicleStatusList: "v1/get/all/fuel/status?type=DEVICE_FUEL_DROP",
    DieselRequestList: "v1/get/fuel/fill/request",
    DieselRequestCreate: "v2/fuel/fill/request/create",
    DieselRequestApprove: "v1/fuel/fill/request/update",
    DieselRequestIssue: "v1/fuel/fill/request/issue",
    DirectIssueRequest: "v1/fuel/fill/direct/issue/request/create",
    DieselIssuedSync: "v1/fuel/fill/request/manual/sync",
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1"
    // DiselStatausList:"api/get/fuelFillRequest?pageSize=1&pageNo=1",
    MenuList: "api/v1/menu/master/getAll",
    SubmenuList: "api/v1/get/all/submenu/master",
    Rolelist: "api/v1/get/allRole",
    savemenusubmenus: "api/v1/save/user/menu/submenu/map/data",
    // subusers endpoints
    SubUsersList: "api/v2/Subuser/all",
    AddSubUser: "api/v2/Subusers/add",
    SubUserById: "api/v2/subUser/byId",
    UpdateSubUser: "api/v2/subUser/update",
    // user vehicle mapping
    vehicleAddForAccess: "api/user/vehicles/details/add",
    existingVehicleAccess: "api/v1/get/user/vehicles/details",
    deleteVehicles: "api/user/vehicles/details/update",
    eventApprover: "v1/support/update/event/status",
    multipleReject: "v1/support/reject/status",
    getAllOrderDetails: "api/v2/etp/orders/get/detail",
    // eventApprover: "v1/support/update/event/status",

    // setings
    getSettings: "api/v1/get/advance/setting",
    settingsUpdate: "api/v1/update/advance/setting",
    getAllReportHeaderConfiguration: "api/get/all/dailyReportHeader",
    updateReportHeaderConfiguration: "api/update/dailyReportHeader",
    passwordGenerator: "api/v1/get/vehicle/lock/passcode",
    saveHeaderConfiger: "api/fuelsummary/dynamic/response",
    fmsDashboardAlldata: "v1/getFuelConsoliedDashboard",
    deviationMaster: "v1/support/getFuelDashboard",
    dayWiseExport: "v1/support/getFuelDetailsForExcel",
    manualFillEvent: "api/v1/calculate/fuel/drop",

    /*...................Trip Management ..............................*/
    vehicleListForAddTrip: "api/v5/get/vehicle/all",
    manualTripCreate: "api/create/manual/trip",
    fileUpload: "https://storage.nyggs.com/setmedia/api/save/file",
    AddVehicleForTrip: "api/v2/vehicle/add",
    tripvalidation: "api/check/trip/validation",
    completeManualTri: "api/complete/manual/trip",
    trackHistoryTracking: "api/reports/route",
    /*...................Utilatization Reports ..............................*/
    equipmentUtilatization: "api/v3/get/all/orders",
    exportExcel: "api/email/specific/export/excel",
    twoStepAuthentication: "api/v1/get/vehicle/lock/passcode",
    distanceReport: "api/v1/vehicle/distance/analysis/report",
    dayWiseEfficiencly: "api/v1/reports/vehicles/dayshift",
    weeklyEfficiencly: "api/v1/reports/vehicles/weekshift",
    shiftType: "api/get/shift",
    lockStatusUpdate: "api/v1/lock-unlock/device",
    /*...................Menu Permission....................*/
    getAllRoles: "v1/role/all",
    getMenuList: "api/v1/menu/master/getAll",
    getSubMenuList: "api/v1/get/all/submenu/master",
    updateMenuPermission: "api/v1/save/user/menu/submenu/map/data",
    getPermissionsByRole: "api/getPermission/by/role",
    websocketEndpoint: "ws",
    // websocketEndpoint: "wss",

    /*...................Geofence in oute notification....................*/
    geofenceNotificayion: "api/get/all/push/notify",
    /*...................Gps Reports ....................*/
    fetchequipmentReports: "api/v1/equipment/all",
    locakDashBoard: "api/get/all/trips",
    bulkerReport: "api/v1/vehicle/weight/log/report",
    /*...................Lock and Otp verify Api ....................*/
    lockTrail: "get/lock/trails",
    sendLockOpt: "api/v1/verify/number/request",
    verifyOtp: "api/v1/verify/otp",
    tripTrail: "get/lock/trails",
    lockStatus: "api/get/last/lock/status",
    lockInventory: "core/v1/getAll",
    tripStoppage: "stoppage/v1/getByTripId",
    addRemarkStoopage: "stoppage/v1/add-remarks",
    lockAssign: "userlockmap/saveAll/v1",

    tripStatus: "lockdashboard/getTripStatus/v1",
    tamperingEvent: "lockdashboard/getTamperingStatus/v1",
    tariffReport: "lockdashboard/getTarrifStatus/v1",
    getLockStatus: "lockdashboard/getStatus/v1",
    inprogressTriplockStatus: "api/inprogress-trip/lock-status",
    BatteryStatusDistribution: "api/lock-battery-status",
    tripweeklycomparison: "api/trip-weekly-comparison",
    tripDetailstLock: "api/trip/prepare",
    routeDetailsList: "api/trip/route",
    alertList: "",
    createTripNew: "api/trip/create",
    createSource: "api/trip/source",
    createDestination: "api/trip/destination",
    tripACtionFore: "api/update/trip/status",
    getAllAlertList: "get/all/alert",
    getAlertList: "get/alert-types",
  },
};
